import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
const lesson: Lesson = {
  id: "2522f162-1fb4-4dd0-9e17-49c88673ba10",
  publicId: "17",
  name: "Synthesis of room impulse responses",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },

  body: [principle01, task01, task02],
};

export default lesson;
